export const team = [
  {
    name: "Yeana Cho",
    github: "https://github.com/yeana-dev",
    linkedin: "https://www.linkedin.com/in/yeana-cho-330312113/",
    email: "yeana.dev@gmail.com",
  },
  {
    name: "Sofanit Tesfaye",
    github: "https://github.com/SofanitTesfaye",
    linkedin: "https://www.linkedin.com/in/sofanit-tesfaye-886267218/",
    email: "sofanittesfaye2@gmail.com",
  },
  {
    name: "Jorge Herrera",
    github: "https://github.com/Jherrera1234",
    linkedin: "https://www.linkedin.com/in/jorge-herrera-bba82a199/",
    email: "jherrera1850@gmail.com",
  },
  {
    name: "Francisco Rosado",
    github: "https://github.com/FranciscoPink",
    linkedin: "hhttps://www.linkedin.com/in/francisco-rosado-b652151a9",
    email: "francisco.rosado.dev@gmail.com",
  },
];
